import axios from "axios";

export const httpMenuAi = axios.create({
  baseURL: process.env.VUE_APP_MENU_AI_URL,
});

export const http_menu_import = axios.create({
  baseURL: process.env.VUE_APP_API_MOBILE_URL,
});

export function getTranscription(files) {
  return httpMenuAi.post("transcribe-images", files);
}

export function getTranscriptionFromPdf(files) {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("file", file);
  });

  return httpMenuAi.post("transcribe-pdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function getParsedMenuFromText(text, allExternal = true, fillImages = false) {
  return httpMenuAi.post("parse-from-text", { text }, {
    params: { allExternal, fillImages },
    headers: {'Content-Type': 'application/json;charset=utf-8' }
  });
}

export function getParsedMenuFromTextCache(text, allExternal = true, fillImages = false) {
  return httpMenuAi.post("parse-from-text-cache", { text }, {
    params: { allExternal, fillImages },
    headers: {'Content-Type': 'application/json;charset=utf-8' }
  });
}

export function checkProcessingStatusCache(uuid) {
  return httpMenuAi.get(`parse-from-text-cache/${uuid}`);
}

export function getParsedMenu(files, allExternal = true) {
  return httpMenuAi.post("parse-menu", files, { params: { allExternal }});
}

export function importToClient(token, json, eraseMenu = false) {
  return http_menu_import.post("instalacoes/ia-beta", { erase: eraseMenu, ...json }, { headers: { Authorization: "Bearer " + token } });
}

//region Icons
export function uploadIcon(url, text) {
  return httpMenuAi.post("icons", { url, text });
}

export function fillIcons(products) {
  return httpMenuAi.post("fill-images", products);
}

export function suggestNcm(products) {
  return httpMenuAi.post("fill-ncm-suggestion", products);
}
//endregion

//region Utils
// Convert file to base64
export function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
}
//endregion
